module.exports = __webpack_public_path__ + "assets/3287de59a4b085ac3b3820e430accee4.woff";